'use client';

import React from 'react';
import type { ReactNode } from 'react';
import { Group as AriaGroup } from 'react-aria-components';
import { Field } from '../field';
import { cx } from '../../../utils/cx';
import useId from '../../../utils/useId';

const SEMANTIC_NAME = 'RomaToggleGroup';

export interface ToggleGroupProps {
    title?: string;
    children: ReactNode;
    className?: string;
}

export const ToggleGroup = ({ title, children, className }: ToggleGroupProps) => {
    const titleId = useId();

    return (
        <AriaGroup
            aria-labelledby={title ? titleId : undefined}
            className={cx(SEMANTIC_NAME, 'flex flex-col gap-md', className)}
            data-toggle-group
        >
            {title && (
                <Field.LabelText id={titleId} size="md" className="text-primary">
                    {title}
                </Field.LabelText>
            )}
            <div className="flex flex-col gap-md">{children}</div>
        </AriaGroup>
    );
};

ToggleGroup.displayName = SEMANTIC_NAME;
